'use client';

import dynamic from 'next/dynamic';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import TechnologyFaq from '@/components/technologies/technology-faq';
import Blog from '@/components/home/blog';
import HireProcessAimlDev from '@/components/technologies/hire-process-aimldev';
import AutomateComplexSolutions from '@/components/common/automate-complex-solution';
import ValuePropositionAiAgent from '@/components/common/value-proposition-ai-agent';
import WhyAgentic from '@/components/common/why-agentic';
import OurOfferingAgentic from '@/components/common/our-offering-agentic';
import TechnicalApproachAIAgents from '@/components/common/technical-approach-aiagent';
import ArchitectureDiagramAiAgents from '@/components/common/architecture-diagram-ai-agents';
import IntegrationsTechAiAgents from '@/components/common/integrations-tech-aiagent';
import AiAgentsFAQ from '@/components/faqs/ai-agents-faq';
import AiAgentTechStack from '@/components/home/ai-agent-tech-stack';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHeroAiAgents = dynamic(() => import('@/components/technologies/tech-hero-ai-agent'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <div className="dark:bg-black">
                <TechHeroAiAgents />
                <AutomateComplexSolutions />
                <ValuePropositionAiAgent />
                <WhyAgentic />
                <OurOfferingAgentic />
                <TechnicalApproachAIAgents />
                <ArchitectureDiagramAiAgents />
                <IntegrationsTechAiAgents />
                <AiAgentTechStack />
                <HireProcessAimlDev
                    bg="bg-black"
                    pageTitle="Our AI/ML Development Process"
                    desc="Maximize the possibilities of the newest AI/ML version. You can hire our AI/ML developers, who are competent in the technical and interactive abilities required to meet your project's objectives."
                />
                <TechnologyFaq title="FAQs for AI Agents & Intelligent Automation" bg="bg-aiml-faq">
                    <AiAgentsFAQ />
                </TechnologyFaq>
                <CaseStudies />
                <section className="">
                    <ClientTestimonials />
                </section>
                <Blog />
                <div className="section bg-primary py-100 dark:text-light dark:bg-black dark:pt-1">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                            <ContactForm />
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
